import {Modal, Spinner} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setRefreshEditModalData} from "../../../../_reducers/activitySlice";
import {addToForceRefresh} from "../../../../_reducers/SearchTableSlice";
import {
    setClientsSettings,
    setEditClient,
    setEditClientMovements,
    setEditClientPayment, setSelectedClientCategory
} from "../../../../_reducers/DataPanel/Clients/clientSlice";
import {toast} from "react-toastify";
import {
    setEditPriceList,
    setEditProductMovements,
    setSelectedEditProduct
} from "../../../../_reducers/DataPanel/Products/productsSlice";
import {
    fetchAccountingSettings,
    fetchCashSettings,
    fetchCategory, fetchPayrollSettings
} from "../../../../_apis/api";
import {setSelectedProductCategory} from "../../../../_reducers/DataPanel/Products/productCategorySlice";
import {
    setSalesGeneralSettings,
    setSelectedPaymentMethod
} from "../../../../_reducers/DataPanel/Sales/salesSettingsSlice";
import {
    setEditSupplier,
    setEditSupplierMovements, setEditSupplierPayment,
    setSelectedSupplierCategory, setSuppliersSettings
} from "../../../../_reducers/DataPanel/Suppliers/supplierSlice";
import {setEditBuys} from "../../../../_reducers/DataPanel/Buys/buysSlice";
import {
    setBuysGeneralSettings,
    setSelectedBuysPaymentMethod
} from "../../../../_reducers/DataPanel/Buys/buysSettingsSlice";
import {setEditBankAccount, setEditCashRegisters, setEditPOS} from "../../../../_reducers/DataPanel/Cash/cashSlice";
import {
    setEditAccountingAccount,
    setEditAccountingRecord,
    setEditEmployee
} from "../../../../_reducers/DataPanel/Accounting/accountingSlice";
import {setEditAdvancedType, setEditBasicType} from "../../../../_reducers/settingsSlice";
import {
    setEditFixedAsset,
    setEditFixedAssetMovement,
    setEditFixedAssetRecord
} from "../../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";

const RefreshEditModal = () => {
    const [spinner, setSpinner] = useState(false);
    const dispatch = useDispatch();
    const modalData = useSelector((state) => state.ACTIVITY.refreshEditModalData);
    const company = useSelector((state) => state.COMPANY_DATA.company);

    const forceRefresh = () => {
        setSpinner(true);
        const documentType = modalData?.documentType;
        const document = modalData?.document;
        if (documentType === "client") {
            dispatch(addToForceRefresh("Client Search"));
            dispatch(setEditClient(document));
        } else if (documentType === "client-movement") {
            dispatch(addToForceRefresh("Client Movements Search"));
            dispatch(setEditClientMovements(document));
        } else if (documentType === "client-settings") {
            dispatch(setSelectedClientCategory({}));
            dispatch(setClientsSettings(document));
        } else if (documentType === "product") {
            dispatch(addToForceRefresh("Search Products"));
            dispatch(setSelectedEditProduct(document));
        } else if (documentType === "product-movement") {
            dispatch(addToForceRefresh("Search Product Movements"));
            dispatch(setEditProductMovements(document));
        } else if (documentType === "price-list") {
            dispatch(addToForceRefresh("Search Product Price List"));
            dispatch(setEditPriceList(document));
        } else if (documentType === "product-category") {
            dispatch(fetchCategory({type: "product", company: company.id, year: company.year, isActive: "active"}));
            dispatch(setSelectedProductCategory({}));
        } else if (documentType === "client-payment") {
            dispatch(addToForceRefresh("Client Payments Search"));
            dispatch(setEditClientPayment(document));
        } else if (documentType === "sales-settings") {
            dispatch(setSelectedPaymentMethod({}));
            dispatch(setSalesGeneralSettings(document));
        } else if (documentType === "supplier") {
            dispatch(addToForceRefresh("Supplier Search"));
            dispatch(setEditSupplier(document));
        } else if (documentType === "supplier-movement") {
            dispatch(addToForceRefresh("Supplier Movements Search"));
            dispatch(setEditSupplierMovements(document));
        } else if (documentType === "supplier-settings") {
            dispatch(setSelectedSupplierCategory({}));
            dispatch(setSuppliersSettings(document));
        } else if (documentType === "buy") {
            dispatch(addToForceRefresh("Buys Search"));
            dispatch(setEditBuys(document));
        } else if (documentType === "supplier-payment") {
            dispatch(addToForceRefresh("Supplier Payments Search"));
            dispatch(setEditSupplierPayment(document));
        } else if (documentType === "buys-settings") {
            dispatch(setSelectedBuysPaymentMethod({}));
            dispatch(setBuysGeneralSettings(document));
        } else if (documentType === "cashRegister") {
            dispatch(setEditCashRegisters(document));
            dispatch(addToForceRefresh("Cash Registers Search"));
        } else if (documentType === "pos") {
            dispatch(setEditPOS(document));
            dispatch(addToForceRefresh("POS Search"));
        } else if (documentType === "bankAccount") {
            dispatch(setEditBankAccount(document));
            dispatch(addToForceRefresh("Bank Account Search"));
        } else if (documentType === "cash-settings") {
            dispatch(fetchCashSettings(company.id));
        } else if (documentType === "employee") {
            dispatch(setEditEmployee(document));
            dispatch(addToForceRefresh("Employees Search"));
        } else if (documentType === "accounting-account") {
            dispatch(setEditAccountingAccount(document));
            dispatch(addToForceRefresh("Accounting Account Search"));
        } else if (documentType === "accounting-record") {
            dispatch(setEditAccountingRecord(document));
            dispatch(addToForceRefresh("Accounting Record Search"));
        } else if (documentType === "accounting-settings") {
            dispatch(fetchAccountingSettings({company: company.id}));
        } else if (documentType === "payroll-settings") {
            dispatch(fetchPayrollSettings(company.id));
        } else if (documentType === "basic-type") {
            dispatch(setEditBasicType(document));
            dispatch(addToForceRefresh("Basic Type Search"));
        } else if (documentType === "advanced-type" || documentType === "advanced-type-sale" || documentType === "advanced-type-buy") {
            dispatch(setEditAdvancedType(document));
            dispatch(addToForceRefresh("Advanced Type Search"));
        } else if (documentType === "fixed-asset") {
            dispatch(setEditFixedAsset(document));
            dispatch(addToForceRefresh("Fixed Assets Search"));
        } else if (documentType === "fixed-asset-movement") {
            dispatch(setEditFixedAssetMovement(document));
            dispatch(addToForceRefresh("Fixed Asset Movements Search"));
        } else if (documentType === "fixed-asset-record") {
            dispatch(setEditFixedAssetRecord(document));
            dispatch(addToForceRefresh("Fixed Asset Records Search"));
        }
        toast.success("Το δεδομένα του εγγράφου ανανεώθηκαν!");
        setSpinner(false);
        closeModal();
    }

    const closeModal = () => dispatch(setRefreshEditModalData({show: false, documentType: "", document: null}));

    return (
        <Modal className={"themeModalSemiMedium"} backdrop={"static"} show={modalData?.show}
               onHide={() => closeModal()}>
            <Modal.Header closeButton>
                <Modal.Title>Απαιτείται Προσοχή!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Το έγγραφο έχει επεξεργαστεί ήδη από άλλο χρήστη και η αποθήκευση των δεδομένων σας δεν μπορεί να
                πραγματοποιηθεί! <br/>
                Μπορείτε να ανανεώσετε το έγγραφο σας με τα τελευταία στοιχεία πατώντας το κουμπί «Ανανέωση Εγγράφου»
                και να συνεχίσετε την επεξεργασία του από την αρχή. <br/>
                Προσοχή τα μη αποθηκευμένα δεδομένα θα χαθούν και θα αντικατασταθούν με τα ανανεωμένα στοιχεία του
                εγγράφου.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={() => closeModal()}>Κλείσιμο</Button>
                <Button variant="primary" onClick={() => forceRefresh()} disabled={spinner}>
                    Ανανέωση Εγγράφου {spinner && (
                    <Spinner className={"ml-2 mr-0"} animation="border" variant="light"/>)}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default RefreshEditModal;
